import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import LoadingModal from './LoadingModal';
import ConfirmModal from './ConfirmModal';
import useConfirmModal from '../hooks/useConfirmModal';
import DemandaItemFormModal from './DemandaItemFormModal';

function DemandaItemModal({ show, onClose, onSuccess, demanda, usuarios }) {
  const [itens, setItens] = useState([]);
  const [historico, setHistorico] = useState([]);
  const [aba, setAba] = useState('itens');
  const [showFormModal, setShowFormModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [itemSelecionado, setItemSelecionado] = useState(null);
  const token = localStorage.getItem('token');
  const { setConfirmModal, showConfirmModal } = useConfirmModal();
  const usuario = JSON.parse(localStorage.getItem('user') || '{}');
  const isOrgaoUser = usuario?.tipoUsuario === 'ORGAO';

  useEffect(() => {
    if (show && demanda) {
      setItemSelecionado(null);
      carregarItens();
      carregarHistorico();
    }
  }, [show, demanda]);

  const carregarItens = () => {
    axios
      .get(`${API_BASE_URL.DEMANDA_ITEM}/demanda/${demanda.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => setItens(res.data))
      .catch(err => console.error('Erro ao carregar itens:', err));
  };

  const carregarHistorico = () => {
    axios
      .get(`${API_BASE_URL.DEMANDA}/${demanda.id}/historico`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => setHistorico(res.data))
      .catch(err => console.error('Erro ao carregar histórico:', err));
  };

  const handleSalvarItem = formData => {
    setLoading(true);

    const payload = {
      descricao: formData.descricao,
      observacao: formData.observacao,
      responsavelCpf: demanda.responsavelCpf || '',
      dataPrazo: demanda.dataPrazo || null,
      status: 'PENDENTE',
      demandaId: demanda.id,
      ordem: editingItem ? editingItem.ordem : itens.length,
    };

    const request = editingItem
      ? axios.put(`${API_BASE_URL.DEMANDA_ITEM}/update`, { ...payload, id: editingItem.id }, {
          headers: { Authorization: `Bearer ${token}` },
        })
      : axios.post(`${API_BASE_URL.DEMANDA_ITEM}/save`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });

    request
      .then(() => {
        setShowFormModal(false);
        setEditingItem(null);
        setItemSelecionado(null);
        carregarItens();
        onSuccess();
      })
      .catch(err => {
        console.error('Erro ao salvar item:', err);
        alert('Erro ao salvar item!');
      })
      .finally(() => setLoading(false));
  };

  const handleExcluirItem = item => {
    showConfirmModal('delete', () => {
      axios
        .delete(`${API_BASE_URL.DEMANDA_ITEM}/delete/${item.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(() => {
          setItemSelecionado(null);
          carregarItens();
          onSuccess();
        })
        .catch(err => console.error('Erro ao excluir item:', err));
    });
  };

  const handleMarcarConcluido = item => {
    const proximoStatus = {
      PENDENTE: 'EM_EXECUCAO',
      EM_EXECUCAO: 'CONCLUIDA',
    };
    const novoStatus = proximoStatus[item.status];
    if (!novoStatus) return;

    const acao = item.status === 'PENDENTE' ? 'iniciar' : 'concluir';

    showConfirmModal(acao, () => {
      axios
        .put(
          `${API_BASE_URL.DEMANDA_ITEM}/update`,
          { ...item, status: novoStatus },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then(() => {
          carregarItens();
          onSuccess();
        })
        .catch(err => console.error('Erro ao atualizar item:', err));
    });
  };

  const getStatusBadge = status => {
    const badges = {
      PENDENTE: 'bg-secondary',
      EM_EXECUCAO: 'bg-warning text-dark',
      CONCLUIDA: 'bg-success',
    };
    return badges[status] || 'bg-secondary';
  };

  const getAcaoLabel = status => {
    if (status === 'PENDENTE') return 'Iniciar';
    if (status === 'EM_EXECUCAO') return 'Concluir';
    return null;
  };

  const getNomeUsuario = cpf => {
    const u = usuarios.find(usr => usr.cpf === cpf);
    return u ? u.nome : cpf || '-';
  };

  const formatarData = data => {
    if (!data) return '-';
    return new Date(data).toLocaleDateString('pt-BR');
  };

  const formatarDataHora = data => {
    if (!data) return '-';
    return new Date(data).toLocaleString('pt-BR');
  };

  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '90vw', height: '90vh' }}>
          <div className="modal-content" style={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div
              className="modal-header text-white py-1"
              style={{
                background:
                  'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)',
                border: 'none',
                flexShrink: 0,
              }}
            >
              <h6 className="modal-title">
                <i className="bi bi-list-check me-2"></i>
                Demanda: {demanda.titulo}
              </h6>
              <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
            </div>
            <div className="modal-body py-2" style={{ flex: 1, overflowY: 'auto' }}>
              <ul className="nav nav-tabs nav-tabs-sm mb-3">
                <li className="nav-item">
                  <button
                    className={`nav-link py-1 ${aba === 'itens' ? 'active' : ''}`}
                    onClick={() => setAba('itens')}
                  >
                    <i className="bi bi-list-check me-1"></i>
                    Tópicos ({itens.length})
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link py-1 ${aba === 'historico' ? 'active' : ''}`}
                    onClick={() => setAba('historico')}
                  >
                    <i className="bi bi-clock-history me-1"></i>
                    Histórico
                  </button>
                </li>
              </ul>

              {aba === 'itens' && (
                <>
                  <div className="d-flex align-items-center mb-1 flex-wrap gap-2" style={{ fontSize: '0.8rem' }}>
                    {!isOrgaoUser && (
                      <>
                        <button
                          className="btn btn-success btn-sm"
                          disabled={demanda.status === 'CONCLUIDA'}
                          onClick={() => { setEditingItem(null); setShowFormModal(true); }}
                        >
                          <i className="bi bi-plus-circle me-1"></i>Novo
                        </button>
                        <button
                          className="btn btn-primary btn-sm"
                          disabled={!itemSelecionado || demanda.status === 'CONCLUIDA'}
                          onClick={() => { if (itemSelecionado) { setEditingItem(itemSelecionado); setShowFormModal(true); } }}
                        >
                          <i className="bi bi-pencil me-1"></i>Editar
                        </button>
                        <button
                          className="btn btn-danger btn-sm"
                          disabled={!itemSelecionado || demanda.status === 'CONCLUIDA'}
                          onClick={() => { if (itemSelecionado) handleExcluirItem(itemSelecionado); }}
                        >
                          <i className="bi bi-trash me-1"></i>Excluir
                        </button>
                      </>
                    )}
                    {itemSelecionado && getAcaoLabel(itemSelecionado.status) && demanda.status !== 'CONCLUIDA' && (
                      <button
                        className={`btn btn-sm ${itemSelecionado.status === 'PENDENTE' ? 'btn-warning' : 'btn-success'}`}
                        onClick={() => handleMarcarConcluido(itemSelecionado)}
                      >
                        <i className={`bi ${itemSelecionado.status === 'PENDENTE' ? 'bi-play-circle' : 'bi-check-circle'} me-1`}></i>
                        {getAcaoLabel(itemSelecionado.status)}
                      </button>
                    )}
                  </div>

                  {itens.length === 0 ? (
                    <div className="text-center text-muted py-4">
                      <i className="bi bi-inbox" style={{ fontSize: '2rem' }}></i>
                      <p className="mt-2">Nenhum tópico cadastrado</p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-sm table-hover" style={{ fontSize: '0.8rem' }}>
                        <thead style={{ background: 'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)', color: '#fff', '--bs-table-color': '#fff' }}>
                          <tr>
                            <th>Descrição</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {itens.map(item => (
                            <tr
                              key={item.id}
                              className={
                                itemSelecionado && itemSelecionado.id === item.id
                                  ? 'table-primary'
                                  : ''
                              }
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                if (itemSelecionado && itemSelecionado.id === item.id) {
                                  setItemSelecionado(null);
                                } else {
                                  setItemSelecionado(item);
                                }
                              }}
                            >
                              <td className={item.status === 'CONCLUIDA' ? 'text-decoration-line-through text-muted' : ''}>
                                {item.descricao}
                                {item.observacao && (
                                  <small className="text-muted d-block">
                                    <i className="bi bi-chat-left-text me-1"></i>
                                    {item.observacao}
                                  </small>
                                )}
                              </td>
                              <td>
                                <span className={`badge ${getStatusBadge(item.status)}`}>
                                  {item.status?.replace('_', ' ')}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              )}

              {aba === 'historico' && (
                <>
                  {historico.length === 0 ? (
                    <div className="text-center text-muted py-4">
                      <i className="bi bi-clock-history" style={{ fontSize: '2rem' }}></i>
                      <p className="mt-2">Nenhum registro no histórico</p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-sm table-hover" style={{ fontSize: '0.8rem' }}>
                        <thead style={{ background: 'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)', color: '#fff', '--bs-table-color': '#fff' }}>
                          <tr>
                            <th>Data/Hora</th>
                            <th>Ação</th>
                            <th>Descrição</th>
                            <th>Usuário</th>
                          </tr>
                        </thead>
                        <tbody>
                          {historico.map(h => (
                            <tr key={h.id}>
                              <td>{formatarDataHora(h.dataHora)}</td>
                              <td>
                                <span className="badge bg-info">{h.acao}</span>
                              </td>
                              <td>{h.descricao}</td>
                              <td>{getNomeUsuario(h.usuarioCpf)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="modal-footer py-2">
              <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
      <DemandaItemFormModal
        show={showFormModal}
        onClose={() => { setShowFormModal(false); setEditingItem(null); }}
        onSave={handleSalvarItem}
        descricao={editingItem?.descricao || ''}
        observacao={editingItem?.observacao || ''}
        isEdit={!!editingItem}
      />
      {isLoading && <LoadingModal />}
      <ConfirmModal {...setConfirmModal} />
    </>
  );
}

export default DemandaItemModal;
